/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'cheveron': {
    width: 16,
    height: 16,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M10.707 7.05L10 6.343 4.343 12l1.414 1.414L10 9.172l4.243 4.242L15.657 12z"/>'
  }
})
